import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "antd";
import usFlag from "../../../img/AmericaFlag.webp";
import krFlag from "../../../img/KoreaFlag.webp";
// import Menu from "antd/lib/menu";
// import "antd/lib/menu/style/css";

const { SubMenu } = Menu;

const MenuMarkup = ({
  mobileVersion,
  activeLinkKey,
  onLinkClick,
  className,
}) => {
  const location = useLocation();

  // Extract base path without "/kr" prefix
  const basePath = location.pathname.replace(/^\/kr/, "");

  // Construct the path for United States and Korea based on the current location
  const usPath = basePath;
  const krPath = `/kr${basePath}`;

  return (
    <Menu
      theme={mobileVersion ? "light" : "light"}
      mode={mobileVersion ? "vertical" : "horizontal"}
      selectedKeys={activeLinkKey === "/" ? [""] : [`${activeLinkKey}`]}
      className={className}
    >
      <SubMenu key="/settings" title="EN/KR">
        {/* <SubMenu key="/country" title="Country"> */}
        <Menu.Item key="/us">
          <Link onClick={onLinkClick} to={usPath}>
            {/* <img src={usFlag} alt="us-flag" style={{ height: "15px" }} /> */}
            United States
          </Link>
        </Menu.Item>
        <Menu.Item key="/kr">
          <Link onClick={onLinkClick} to={krPath}>
            {/* <img src={krFlag} alt="kr-flag" style={{ height: "20px" }} /> */}
            대한민국
          </Link>
        </Menu.Item>
        {/* </SubMenu> */}
      </SubMenu>

      <Menu.Item key="/allcats">
        <Link onClick={onLinkClick} to="/allcats">
          All Cats
        </Link>
      </Menu.Item>
      <Menu.Item key="/comparecats">
        <Link onClick={onLinkClick} to="/comparecats">
          Compare Cats
        </Link>
      </Menu.Item>
      <Menu.Item key="/allenemies">
        <Link onClick={onLinkClick} to="/allenemies">
          Enemies
        </Link>
      </Menu.Item>
      <SubMenu key="/allstages" title="Stages">
        <Menu.Item key="/bystagename">
          <Link onClick={onLinkClick} to="/allstages/search-by-stage-name">
            By Stage Name
          </Link>
        </Menu.Item>
        <Menu.Item key="/bystageenemies">
          <Link onClick={onLinkClick} to="/allstages/search-by-stage-enemies">
            By Enemies (Monthly Missions)
          </Link>
        </Menu.Item>
      </SubMenu>
      <SubMenu key="/bestcats" title="Best Cats">
        <Menu.Item key="/bestcatsattack">
          <Link onClick={onLinkClick} to="/best-cats-for-attack">
            Best Cats for Attack
          </Link>
        </Menu.Item>
        <Menu.Item key="/bestcatshealth">
          <Link onClick={onLinkClick} to="/best-cats-for-health">
            Best Cats for Health
          </Link>
        </Menu.Item>
        <Menu.Item key="/bestcatsrange">
          <Link onClick={onLinkClick} to="/best-cats-for-range">
            Best Cats for Range
          </Link>
        </Menu.Item>
        <Menu.Item key="/bestcatsspeed">
          <Link onClick={onLinkClick} to="/best-cats-for-speed">
            Best Cats for Speed
          </Link>
        </Menu.Item>
        <Menu.Item key="/bestcatsmeatshields">
          <Link onClick={onLinkClick} to="/best-cats-for-meatshields">
            Best Cats for Meatshields
          </Link>
        </Menu.Item>
      </SubMenu>
      <SubMenu key="/tierlist" title="Tier List">
        <Menu.Item key="/ultrasoulstierlist">
          <Link onClick={onLinkClick} to="/ultra-souls-tier-list">
            Ultra Souls
          </Link>
        </Menu.Item>
        <Menu.Item key="/dynamitestierlist">
          <Link onClick={onLinkClick} to="/dynamites-tier-list">
            Dynamites
          </Link>
        </Menu.Item>
        <Menu.Item key="/galaxygalstierlist">
          <Link onClick={onLinkClick} to="/galaxy-gals-tier-list">
            Galaxy Gals
          </Link>
        </Menu.Item>
        <Menu.Item key="/almightiestierlist">
          <Link onClick={onLinkClick} to="/almighties-tier-list">
            Almighties
          </Link>
        </Menu.Item>
        <Menu.Item key="/lugastierlist">
          <Link onClick={onLinkClick} to="/lugas-tier-list">
            Lugas
          </Link>
        </Menu.Item>
      </SubMenu>
      {/* <Menu.Item key="/merchandise">
      <Link onClick={onLinkClick} to="/merchandise">
        Merchandise
      </Link>
    </Menu.Item> */}
      <Menu.Item key="/faq">
        <Link onClick={onLinkClick} to="/faq">
          About
        </Link>
      </Menu.Item>
    </Menu>
  );
};

MenuMarkup.propTypes = {
  mobileVersion: PropTypes.bool,
  activeLinkKey: PropTypes.string.isRequired,
  onLinkClick: PropTypes.func,
  className: PropTypes.string,
};

MenuMarkup.defaultProps = {
  mobileVersion: false,
  className: "mobile-navigation",
};

export default MenuMarkup;



// WEBPACK FOOTER //
// ./src/components/menu/MenuMarkup/MenuMarkup.js